import Modal from 'react-modal';

const ModalMsgControl = ({
    txtMsg = '',
    active = false,
    closeModal = () => { }
}: IModalProps) => {

    return (
        <Modal className="modal" isOpen={active} ariaHideApp={false}>
            <div className="modal-title">
                <span className="txt-title-modal">Información</span>
            </div>
            <div className="modal-body-info">
                {txtMsg}
            </div>
            <div className="modal-footer">
                <button className="modal-btn-close" onClick={closeModal}>Cerrar</button>
            </div>
        </Modal>

    )
}

export { ModalMsgControl }